export default "__VITE_ASSET__5mRxd9B0__"